import * as icons from "assets/svg";

export const iconsList = {
  ...icons,
};
